<template>
  <el-container direction="vertical">
    <el-row>
      <el-col :span="4">
        <el-input v-model="params.task_id" prefix-icon="el-icon-search" placeholder="输入任务ID查询" clearable @change="onSearch()" />
      </el-col>
      <el-col :span="4">
        <el-input v-model="params.device_name" prefix-icon="el-icon-search" placeholder="输入设备名称查询" clearable @change="onSearch()" />
      </el-col>

      <el-col :span="4">
        <el-input v-model="params.owner_org_name" prefix-icon="el-icon-search" placeholder="输入所属客户查询" clearable @change="onSearch()" />
      </el-col>

      <el-col :span="3">
        <el-select class="remote-select" v-model="params.user_id" @change="onSearch" placeholder="选择责任人查询" clearable>
          <el-option
            v-for="item in share.userList"
            :key="item.value"
            :label="item.text"
            :value="item.value">
          </el-option>
        </el-select>
      </el-col>

      <el-col :span="3">
        <el-select class="remote-select" v-model="params.task_status" placeholder="选择任务状态查询" clearable @change="onSearch()">
          <el-option
            v-for="item in TaskStatuList"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </el-col>

      <el-col :span="3">
        <el-select v-model="params.is_virtual" placeholder="全部任务类别" clearable @change="onSearch()" >
          <el-option
            v-for="item in virtuals"
            :key="item.value"
            :label="item.name"
            :value="item.value" />
        </el-select>
      </el-col>

      <el-col :span="2" class="col_pos_right" align="right">
        <el-button class="btn btn_1" @click="onSearch()">刷新</el-button>
      </el-col>
    </el-row>

    <el-container>
      <el-table :data="pageData.items" stripe border :height="$setTableHeight(1, 0)" :header-cell-style="{textAlign: 'center'}" :cell-style="{textAlign: 'center'}">
        <el-table-column label="任务ID" fixed>
          <template slot-scope="scope">
            <span class="taskIdClass" @click="viewWarningInfo(scope.row)">{{scope.row.task_id}}</span>
          </template>
        </el-table-column>
        <el-table-column v-for="it in tableColList" :key="it.key" :label="it.name" :fixed="it.fixed">
          <template slot-scope="scope">
            <span>{{getRowKeyVal(scope.row, it)}}</span>
          </template>
        </el-table-column>

        <el-table-column fixed="right" min-width="180" label="操作">
          <template slot-scope="scope">
            <el-link v-for="item in operationShow" :key="item.key" :type="item.type" :disabled="item.disabled && item.disabled(scope.row.task_status, scope.row.user_id)" @click="handleClick(item.operation, scope.row)">{{item.title}}</el-link>

            <el-dropdown v-if="operationHide.length" trigger="click" @command="(command)=>handleClick(command, scope.row)">
              <span class="el-dropdown-link"><i class="el-icon-more"></i></span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for="item in operationHide" :key="item.key" :command="item.operation" :disabled="item.disabled && item.disabled(scope.row.task_status, scope.row.user_id)">{{ item.title }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <!-- <template v-if="scope.row.task_status !== 3">
              <el-link v-permission="'编辑任务'" :disabled="!isCurrentUser(scope.row.user_id)" @click="dealRow(scope.row)">处理</el-link>
              <el-link v-permission="'转发任务'" @click="forwardRow(scope.row)">转发</el-link>
              <el-link v-permission="'完成任务'" :disabled="!isCurrentUser(scope.row.user_id)" @click="completeTaskRow(scope.row)">完成任务</el-link>
            </template>
            <el-link v-permission="'查看操作处理流程'" @click="viewProcessRow(scope.row)">查看处理流程</el-link> -->
          </template>
        </el-table-column>
      </el-table>
    </el-container>

    <el-pagination
      background
      style="margin-top:14px"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pageData.total"
      :current-page="pageData.page"
      @current-change="onPageChange"
      :page-size="params.max_results"
      :page-sizes="$pageSizes"
      @size-change="onPageSizeChange">
    </el-pagination>

    <el-dialog width="800px" :title="title" :visible.sync="dialogVisible" append-to-body :close-on-click-modal="false" :close-on-press-escape="false" @closed="componet_select = ''">
      <component :is="componet_select" :rowData="rowData" @tableCloseDialog="dialogVisible = false" />
    </el-dialog>
  </el-container>
</template>

<script>
import Backend from '@/api/backend'
import BasicDataHelper from '@/api/basic_data_helper'
import taskDeal from './deal'
import taskForward from './forward'
import taskViewProcess from './viewProcess'
import warningInfo from './warningInfo'
import { Permiss } from '@/api/permission'

export default {
  data () {
    const userRole = localStorage.user_roles
    const userId = localStorage.user_id
    return Backend.initListPage(this, 'task', {
      route_name: '任务列表',
      id_name: 'task_id',
      userRole: userRole,
      TaskStatuList: BasicDataHelper.TaskStatuList,
      tableColList: [
        {
          key: 'device_name',
          name: '设备名称',
          parent: 'device'
        },
        {
          key: 'device_model_name',
          name: '设备型号',
          parent: 'device'
        },
        {
          key: 'owner_org_name',
          name: '所属客户',
          parent: 'device'
        },
        {
          key: 'user_name',
          name: '责任人'
        },
        {
          key: 'task_status_desp',
          name: '任务状态'
        },
        {
          key: 'task_start_time',
          name: '开始时间'
        },
        {
          key: 'task_complete_time',
          name: '完成时间'
        }
      ],
      operations: [
        {
          key: 'deal',
          title: '处理',
          icon: 'iconfont icon-quchuli icon_11',
          permiss: '保存任务',
          operation: 'dealRow',
          type: 'primary',
          disabled: (status, id) => { return status === 3 || userId !== id }
        },
        {
          key: 'forward',
          title: '转发',
          icon: 'icon-tongjizhuanfa icon_1',
          permiss: '转发任务',
          operation: 'forwardRow',
          type: 'danger',
          disabled: (status) => { return status === 3 }
        },
        {
          key: 'completeTask',
          title: '完成任务',
          icon: 'icon-wancheng icon_7',
          permiss: '完成任务',
          operation: 'completeTaskRow',
          disabled: (status, id) => { return status === 3 || userId !== id }
        },
        {
          key: 'viewProcess',
          title: '查看处理流程',
          icon: 'icon-zhiduliucheng icon_6',
          permiss: '查看操作处理流程',
          operation: 'viewProcessRow'
        }
      ],
      operationData: [],
      sortOperationData: [],
      virtuals: BasicDataHelper.virtuals,
      params: {
        task_id: '',
        device_name: '',
        owner_org_id: '',
        user_id: '',
        task_status: '',
        is_virtual: null
      },
      share: {
        userList: []
      },
      dialogVisible: false,
      title: '',
      componet_select: '',
      rowData: {}
    })
  },

  components: {
    'task-deal': taskDeal,
    'task-forward': taskForward,
    'task-viewProcess': taskViewProcess,
    'warning-info': warningInfo
  },

  computed: {
    operationShow () {
      return this.sortOperationData.slice(0, 2)
    },
    operationHide () {
      return this.sortOperationData.slice(2)
    }
  },

  created () {
    this.operationData = this.$operationsFilter(this.operations)
    this.getUserFuncCount(this.operationData.map(it => Permiss[it.permiss]))

    Backend.filterKeyValueList(this, 'user', '/warning_user/-1')
  },

  methods: {
    getRowKeyVal (row, it) {
      return it.parent ? (row[it.parent] ? row[it.parent][it.key] : '') : row[it.key]
    },
    getUserFuncCount (funcIds) {
      if (funcIds.length < 1) return
      const arr = []
      Backend.post(this, '/role/get_user_func_count', { func_ids: funcIds }).then((data) => {
        data.sorted.forEach(id => {
          arr.push(this.operationData.find(it => Number(Permiss[it.permiss]) === Number(id)))
        })
        this.sortOperationData = arr
      }).catch(() => {
        this.sortOperationData = this.operationData
      })
    },
    onSearch () {
      Backend.queryList(this, this.pageData.filter, 0)
    },
    onPageChange (v) {
      Backend.queryList(this, this.pageData.filter, v)
    },
    onPageSizeChange (v) {
      this.params.max_results = v
      Backend.queryList(this, this.pageData.filter, this.pageData.page === 0 ? 1 : this.pageData.page)
    },
    isCurrentUser (id) {
      return localStorage.user_id === id
    },
    generalFunc (title, componet, row) {
      this.title = title
      this.dialogVisible = true
      this.componet_select = componet
      this.selectDeviceId = row.device_id
      this.rowData = row
    },
    handleClick (operation, row) {
      if (operation) this[operation](row)
    },
    dealRow (row) {
      if (this.isCurrentUser(row.user_id)) {
        this.generalFunc(`任务处理: (ID: ${row.task_id})`, 'task-deal', row)
      }
    },
    forwardRow (row) {
      this.generalFunc(`任务转发: (ID: ${row.task_id})`, 'task-forward', row)
    },
    viewProcessRow (row) {
      this.generalFunc(`处理流程: (ID: ${row.task_id})`, 'task-viewProcess', row)
    },
    viewWarningInfo (row) {
      this.generalFunc(`报警信息: (ID: ${row.task_id})`, 'warning-info', row)
    },
    completeTaskRow (row) {
      if (this.isCurrentUser(row.user_id)) {
        this.$confirm('确定要提交完成该任务？', `提交: (ID: ${row.task_id})`, {
          type: 'warning'
        }).then(() => {
          Backend.post(this, '/task/complete_task', { task_id: row.task_id }).then((data) => {
            row.task_status = data.task_status
            row.task_status_desp = data.task_status_desp
            row.task_complete_time = data.task_complete_time
          }).catch(e => {})
        }).catch(e => {})
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .taskIdClass{
    cursor: pointer;
    color:#3788dc;
    &:hover{
      color:#044c9e;
      text-decoration: underline;
    }
  }
</style>
